import { render, staticRenderFns } from "./EmpresaEdit.vue?vue&type=template&id=0ff312ec&scoped=true&"
import script from "./EmpresaEdit.vue?vue&type=script&lang=ts&"
export * from "./EmpresaEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff312ec",
  null
  
)

export default component.exports